module.exports = __webpack_public_path__ + "static/media/maquininha.806f0b26.png";